import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { PersonasRoutingModule } from './personas-routing.module';
import { PersonasComponent } from './personas.component';
import { BotonToggleModule } from '../boton/boton-toggle.module';
import { ListadoPersonasComponent } from './listado-personas/listado-personas.component';
import { ProspectoService } from '../../providers/prospecto.service';
import { PersonasService } from '../../providers/personas.service';
import { ComunicacionService } from '../../providers/comunicacion.service';
import { InicialesComponent } from '../iniciales/iniciales.component';
import { PipesModule } from '../../pipes/pipes.module';
import { AccionesPropuestaModule } from '../propuestas/acciones-propuesta/acciones-propuesta.module';
import { CrearProspectoComponent } from '../../forms/prospectos/crear-prospecto/crear-prospecto.component';
import { CrearProspectoDialog } from '../../forms/prospectos/crear-prospecto/crear-prospecto-dialog/crear-prospecto-dialog.component';
import { EntidadModule } from '../../forms/entidad/entidad.module';
import { EntidadResponsableModule } from '../../forms/entidad/entidad-responsables/entidad-responsable.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { DireccionService } from '../../providers/direccion.service';
import { TipoClienteService } from '../../forms/clientes/tipos-cliente/tipo-cliente/tipo-cliente.service';
import { IrTipoClienteComponent } from '../../forms/clientes/tipos-cliente/ir-tipo-cliente/ir-tipo-cliente.component';
import { TipoClienteModule } from '../../forms/clientes/tipos-cliente/tipo-cliente.module';
import { ProspectoModule } from '../../forms/prospectos/prospecto.module';
import { RouterModule } from '@angular/router';
import { ClienteModule } from '../../forms/clientes/cliente.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { InicialesModule } from '../iniciales/iniciales.module';
import { EnviarWhatsappComponent, DialogEnviarWhatsapp } from './enviar-whatsapp/enviar-whatsapp.component';
import { TelefonoModule } from '../telefono/telefono.module';
import { IncidenciaModule } from '../../forms/incidencias/incidencia.module';
import { CotizacionModule } from '../../forms/cotizaciones/cotizacion.module';
import { ImportarDialog } from './dialog-importar/importar-dialog.component';
import { ArchivoModule } from '../archivo/archivo.module';

@NgModule({
  declarations:
    [
      PersonasComponent,
      ListadoPersonasComponent,
      EnviarWhatsappComponent,
      DialogEnviarWhatsapp,
      // InicialesComponent,
      ImportarDialog,
    ],
  imports: [
    CommonModule,
    MaterialModule,
    // ReactiveFormsModule,
    FormsModule,
    PersonasRoutingModule,
    BotonToggleModule,
    PipesModule,
    AccionesPropuestaModule,
    EntidadModule,
    EntidadResponsableModule,
    NgxPermissionsModule.forChild(),
    TipoClienteModule,
    ProspectoModule,
    RouterModule,
    ClienteModule,
    InicialesModule,
    TelefonoModule,
    IncidenciaModule,
    CotizacionModule,
    ArchivoModule,

  ],
  exports:
    [
      ListadoPersonasComponent,
      DialogEnviarWhatsapp,
      // InicialesComponent,
      ImportarDialog
    ],
  providers: [
    PersonasService,
    ProspectoService,
    ComunicacionService,
    DireccionService,
    TipoClienteService
  ],
  entryComponents: [
    DialogEnviarWhatsapp,
    ImportarDialog,

  ],
})
export class PersonasModule { }
